import React from "react";
import classNames from "classnames";
import { LoadingSpinnerSize } from "types/loadingSpinner";

import styles from "./LoadingSpinner.module.scss";

interface Props {
    className?: string;
    absoluteCenter?: boolean;
    relativeCenter?: boolean;
    size: LoadingSpinnerSize;
}

const LoadingSpinner = ({ className, absoluteCenter, relativeCenter, size }: Props) => {
    const Loader = () => (
        <div
            className={classNames(styles["loading-spinner"], className, {
                [styles["loading-spinner--large"]]: size === LoadingSpinnerSize.large,
                [styles["loading-spinner--medium"]]: size === LoadingSpinnerSize.medium,
                [styles["loading-spinner--small"]]: size === LoadingSpinnerSize.small,
            })}
        />
    );
    if (relativeCenter) {
        return (
            <div className={styles["loading-spinner--relative-center"]}>
                <Loader />
            </div>
        );
    }
    if (absoluteCenter) {
        return (
            <div className={styles["loading-spinner--absolute-center"]}>
                <Loader />
            </div>
        );
    }
    return <Loader />;
};

export default LoadingSpinner;
